import { TFunction } from "next-i18next";
import { ArrowRightOutlineIcon } from "@smile2impress/components";
import { withCdnUrl } from "@smile2impress/attraction-utils";
import { BaseLayoutContent } from "layouts/relaunch/RelaunchLayout/RelaunchLayout.types";

import { ContactTypes, SocialTypes } from "constants/enum";
import contacts from "configs/contacts";
import { getCurrentYear } from "utils/date";
import { PageContentProps } from "content/content.types";
import {
    OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE,
    UrlsConfig,
} from "configs/urlsConfig";

const pageContent = (
    t: TFunction,
    { locale }: PageContentProps
): BaseLayoutContent => ({
    header: {
        menuTitle: t("navigationMenuRelaunch:navigationMenu"),
        logoLink: UrlsConfig.MAIN,
        items: [
            {
                text: t("navigationMenuRelaunch:clusterBAlignersGroup"),
                highlighted: true,
                items: [
                    {
                        text: t("navigationMenuRelaunch:clusterBOurAligners"),
                        link: UrlsConfig.ALIGNERS,
                        image: {
                            images: [
                                {
                                    webp: withCdnUrl(
                                        "/images/relaunch/common/navigation/clusterB/aligners.webp"
                                    ),
                                },
                            ],
                            defaultSrc: withCdnUrl(
                                "/images/relaunch/common/navigation/clusterB/aligners.webp"
                            ),
                        },
                    },
                    {
                        text: t("navigationMenuRelaunch:malocclusion"),
                        link: UrlsConfig.MALOCCLUSION,
                        image: {
                            images: [
                                {
                                    webp: withCdnUrl(
                                        "/images/relaunch/common/navigation/clusterB/misalignment.webp"
                                    ),
                                },
                            ],
                            defaultSrc: withCdnUrl(
                                "/images/relaunch/common/navigation/clusterB/misalignment.webp"
                            ),
                        },
                    },
                    {
                        text: t(
                            "navigationMenuRelaunch:clusterBQualityTechnology"
                        ),
                        link: UrlsConfig.QUALITY_TECHNOLOGY,
                        image: {
                            images: [
                                {
                                    webp: withCdnUrl(
                                        "/images/relaunch/common/navigation/clusterB/quality.webp"
                                    ),
                                },
                            ],
                            defaultSrc: withCdnUrl(
                                "/images/relaunch/common/navigation/clusterB/quality.webp"
                            ),
                        },
                    },
                    {
                        text: t("navigationMenuRelaunch:clusterBRetainers"),
                        link: UrlsConfig.RETAINERS_SUBSCRIPTION,
                        image: {
                            images: [
                                {
                                    webp: withCdnUrl(
                                        "/images/relaunch/common/navigation/clusterB/retainers.webp"
                                    ),
                                },
                            ],
                            defaultSrc: withCdnUrl(
                                "/images/relaunch/common/navigation/clusterB/retainers.webp"
                            ),
                        },
                    },
                ],
            },
            {
                text: t("navigationMenuRelaunch:navigationPricing"),
                link: UrlsConfig.PRICES,
                image: {
                    images: [
                        {
                            png: withCdnUrl(
                                "/images/relaunch/common/navigation/prices.png"
                            ),
                        },
                    ],
                    defaultSrc: withCdnUrl(
                        "/images/relaunch/common/navigation/prices.png"
                    ),
                },
            },
            {
                text: t("navigationMenuRelaunch:navigationWhitening"),
                link: UrlsConfig.WHITENING,
                image: {
                    images: [
                        {
                            png: withCdnUrl(
                                "/images/relaunch/common/navigation/whitening.png"
                            ),
                        },
                    ],
                    defaultSrc: withCdnUrl(
                        "/images/relaunch/common/navigation/whitening.png"
                    ),
                },
            },
            {
                text: t("navigationMenuRelaunch:clusterBTreatmentGroup"),
                items: [
                    {
                        text: t("navigationMenuRelaunch:clusterBTreatment"),
                        link: UrlsConfig.MAIN_TREATMENT,
                        image: {
                            images: [
                                {
                                    webp: withCdnUrl(
                                        "/images/relaunch/common/navigation/clusterB/treatment.webp"
                                    ),
                                },
                            ],
                            defaultSrc: withCdnUrl(
                                "/images/relaunch/common/navigation/clusterB/treatment.webp"
                            ),
                        },
                    },
                    {
                        text: t(
                            "navigationMenuRelaunch:clusterBBeforeTreatment"
                        ),
                        link: UrlsConfig.BEFORE_THE_TREATMENT,
                        image: {
                            images: [
                                {
                                    webp: withCdnUrl(
                                        "/images/relaunch/common/navigation/clusterB/before-treatment.webp"
                                    ),
                                },
                            ],
                            defaultSrc: withCdnUrl(
                                "/images/relaunch/common/navigation/clusterB/before-treatment.webp"
                            ),
                        },
                    },
                    {
                        text: t(
                            "navigationMenuRelaunch:clusterBDuringTreatment"
                        ),
                        link: UrlsConfig.DURING_THE_TREATMENT,
                        image: {
                            images: [
                                {
                                    webp: withCdnUrl(
                                        "/images/relaunch/common/navigation/clusterB/during-treatment.webp"
                                    ),
                                },
                            ],
                            defaultSrc: withCdnUrl(
                                "/images/relaunch/common/navigation/clusterB/during-treatment.webp"
                            ),
                        },
                    },
                    {
                        text: t(
                            "navigationMenuRelaunch:clusterBAfterTreatment"
                        ),
                        link: UrlsConfig.AFTER_THE_TREATMENT,
                        image: {
                            images: [
                                {
                                    webp: withCdnUrl(
                                        "/images/relaunch/common/navigation/clusterB/after-treatment.webp"
                                    ),
                                },
                            ],
                            defaultSrc: withCdnUrl(
                                "/images/relaunch/common/navigation/clusterB/after-treatment.webp"
                            ),
                        },
                    },
                ],
            },
            {
                text: t("navigationMenuRelaunch:navigationClinics"),
                link: UrlsConfig.LOCATIONS,
                image: {
                    images: [
                        {
                            png: withCdnUrl(
                                "/images/relaunch/common/navigation/locations.png"
                            ),
                        },
                    ],
                    defaultSrc: withCdnUrl(
                        "/images/relaunch/common/navigation/locations.png"
                    ),
                },
            },
            {
                text: t("navigationMenuRelaunch:navigationResults"),
                link: UrlsConfig.RESULTS,
                image: {
                    images: [
                        {
                            png: withCdnUrl(
                                "/images/relaunch/common/navigation/results.png"
                            ),
                        },
                    ],
                    defaultSrc: withCdnUrl(
                        "/images/relaunch/common/navigation/results.png"
                    ),
                },
            },
            {
                text: t("navigationMenuRelaunch:navigationBlog"),
                link: UrlsConfig.BLOG,
                image: {
                    images: [
                        {
                            png: withCdnUrl(
                                "/images/relaunch/common/navigation/blog.png"
                            ),
                        },
                    ],
                    defaultSrc: withCdnUrl(
                        "/images/relaunch/common/navigation/blog.png"
                    ),
                },
            },
        ],
        cta: {
            text: t("navigationMenuRelaunch:navigationCTA"),
            link: UrlsConfig.UNIVERSAL_FORM,
        },
        ctaExpanded: {
            text: t("navigationMenuRelaunch:navigationCTA2"),
            link: UrlsConfig.UNIVERSAL_FORM,
            iconRight: ArrowRightOutlineIcon,
        },
        candidate: {
            text: t("navigationMenuRelaunch:navigationQuiz"),
            link: UrlsConfig.CANDIDATE,
        },
    },
    contacts: {
        wa: {
            text: t("navigationMenuRelaunch:navigationWhatsApp"),
            link: contacts.whatsapp[locale].link,
            newPatientsLink: (contacts.whatsapp[locale] as any).newPatientsLink,
            message: t("global:whatsappMessage"),
        },
    },
    footer: {
        company: {
            title: t("global:companyFooterText"),
            links: [
                {
                    id: "whyImpress",
                    name: t("global:whyImpressPageTitle"),
                    link: UrlsConfig.WHY_IMPRESS,
                },
                {
                    id: "blog",
                    name: t("global:blogPageTitle"),
                    link: UrlsConfig.BLOG,
                },
                {
                    id: "careers",
                    name: t("global:careersPageTitle"),
                    link: "https://www.linkedin.com/company/impress-orthodontics/jobs/",
                },
                {
                    id: "locations",
                    name: t("navigationMenuRelaunch:navigationClinics"),
                    link: UrlsConfig.LOCATIONS,
                },
                {
                    id: "offersAndDiscounts",
                    name: t("navigationMenuRelaunch:offersAndDiscounts"),
                    link: OFFERS_AND_DISCOUNTS_LINKS_BY_LOCALE[locale],
                },
                {
                    id: "studentbeans",
                    name: t("navigationMenuRelaunch:studentBeans"),
                    link: UrlsConfig.STUDENT_BEANS,
                },
            ],
        },
        product: {
            title: t("global:productFooterText"),
            links: [
                {
                    name: t("navigationMenuRelaunch:clusterBOurAligners"),
                    link: UrlsConfig.ALIGNERS,
                },
                {
                    name: t("navigationMenuRelaunch:clusterBCrookedTeeth"),
                    link: UrlsConfig.CROOKED_TEETH,
                },
                {
                    name: t("navigationMenuRelaunch:clusterBCrowding"),
                    link: UrlsConfig.CROWDING,
                },

                {
                    name: t("navigationMenuRelaunch:clusterBOverbite"),
                    link: UrlsConfig.OVERBITE,
                },
                {
                    name: t("navigationMenuRelaunch:clusterBCrossbite"),
                    link: UrlsConfig.CROSSBITE,
                },
                {
                    name: t("navigationMenuRelaunch:clusterBDiastema"),
                    link: UrlsConfig.DIASTEMA,
                },
                {
                    name: t("navigationMenuRelaunch:clusterBUnderbite"),
                    link: UrlsConfig.UNDERBITE,
                },
            ],
        },
        legal: {
            title: t("global:legalNoticeFooterTitle"),
            links: [
                {
                    name: t("navigationMenuRelaunch:clusterBImpressum"),
                    link: "http://smile2impress-5970216.hs-sites.com/nl-nl/juridisch/impressum/",
                },
                {
                    name: t("navigationMenuRelaunch:clusterBDataProtection"),
                    link: "http://smile2impress-5970216.hs-sites.com//juridisch/privacybeleid/",
                },
                {
                    name: t("navigationMenuRelaunch:clusterBComplaints"),
                    link: UrlsConfig.COMPLAINTS,
                },
            ],
        },
        support: {
            title: t("global:supportFooterText"),
            links: [
                {
                    id: "faq",
                    name: t("global:faqFooterText"),
                    link: "https://faq.smile2impress.com/nl",
                },
                {
                    id: ContactTypes.PHONE,
                    name: contacts.phone[locale].public,
                    link:
                        contacts.phone[locale].link &&
                        `tel:${contacts.phone[locale].link}`,
                },
                {
                    id: SocialTypes.WA,
                    name: "WhatsApp",
                    link: (contacts.whatsapp[locale] as any).newPatientsLink,
                },
                {
                    name: t("global:email"),
                    link: `mailto:customer.nl@smile2impress.com`,
                },
            ],
        },
        disclaimerContent: t("global:disclaimerContent"),
        copyright: {
            text: `© ${getCurrentYear()} SMILE2IMPRESS SL. ${t(
                "global:copyright"
            )}`,
        },
        socialNetworks: [
            {
                iconName: SocialTypes.INSTAGRAM,
                link: contacts.instagram[locale].link,
            },
            {
                iconName: SocialTypes.FB,
                link: contacts.facebook[locale].link,
            },
            {
                iconName: SocialTypes.LINKDIN,
                link: contacts.linkdin[locale].link,
            },
            {
                iconName: SocialTypes.TIKTOK,
                link: contacts.tiktok[locale].link,
            },
        ],
        workingHours: {
            weekdays: "",
            weekends: "",
        },
    },
});

export default pageContent;
